import { render } from "./RuleForwardGroup.vue?vue&type=template&id=1a4e4426&scoped=true"
import script from "./RuleForwardGroup.vue?vue&type=script&lang=js"
export * from "./RuleForwardGroup.vue?vue&type=script&lang=js"

import "./RuleForwardGroup.vue?vue&type=style&index=0&id=1a4e4426&scoped=true&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4e4426"]])

export default __exports__